import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Sprite from '~components/Sprite'

class Swatch extends Component {
  constructor () {
    super()

    this.state = {
      open: false
    }
  }

  toggleFilter (e) {
    const open = this.state.open

    this.setState((state) => {
      return { open: !open }
    })
  }

  toggleView () {
    this.toggleFilter()
    this.props.onClick && this.props.onClick()
  }

  render () {
    return (
      <div className={classNames('relative', this.props.className)}>
        <button type="button" className={classNames('transition-colors duration-150 ease-in-out h-12 pl-4 pr-10 cursor-pointer border-grey border rounded bg-no-repeat bg-right-4 bg-3 appearance-none outline-none focus:border-charcoal hover:border-charcoal', { 'bg-chevron-down': !this.state.open }, { 'bg-chevron-up': this.state.open })} aria-label="Choose view" onClick={() => this.toggleFilter()}>
          <span className="block w-8 h-4" aria-hidden="true">
            <Sprite name={this.props.listView ? 'spaces' : 'bars'} />
          </span>
        </button>

        <button type="button" className={classNames('absolute transition-colors duration-150 ease-in-out h-12 px-4 cursor-pointer border-grey border rounded outline-none bg-grey flex items-center mt-0.5 left-0 top-full min-w-38 z-10 hover:bg-opacity-75 focus:bg-opacity-75', { hidden: !this.state.open })} aria-label="Grid view" onClick={() => this.toggleView()}>
          <span className="block w-8 h-4 mr-4" aria-hidden="true">
            <Sprite name={this.props.listView ? 'bars' : 'spaces'} />
          </span>

          {this.props.listView ? 'Grid view' : 'List view'}
        </button>
      </div>
    )
  }
}

Swatch.propTypes = {
  onClick: PropTypes.func,
  listView: PropTypes.bool.isRequired,
  className: PropTypes.string
}

export default Swatch
